
jQuery(document).ready(function() {
    function postForm(ev,form)
    {
        $.ajax({
                url: ajaxurl,
                type: form.attr('method'),
                data: form.serialize(),
                //dataType: 'json', // JSON
                beforeSend: function(message) {
                    $('#modalContact').foundation('open');
                    loader.load();
                },
                success: function(message) {
                    if(/error/.test(message))
                    {
                        loader.error();  
                    }
                    else
                    {
                        loader.success();
                    }
                    $('#contentContact').html(message);
                }
            });
    }
    var loader = {
        init: function() {
            loader.setVariables();
        },
        setVariables: function() { 
            loader.$loader = $(".loader");
            loader.isLoading = false;
            loader.currentTimeout = null;
        },
        //Startet lade Animation
        load: function() {
            if (this.currentTimeout !== null) {
              window.clearTimeout(this.currentTimeout);
            }
            loader.$loader.removeClass("success").removeClass("error");
            loader.$loader.addClass("loading");
            loader.isLoading = true;
        },
        //Startet success Animation
        success: function() {
            this.currentTimeout = window.setTimeout(function() {
                loader.$loader
                    .removeClass("loading")
                    .addClass("success");
                this.currentTimeout = window.setTimeout(loader.hide, 3000);
                loader.isLoading = false;
            }, 100);
        },
        //Startet error Animation
        error: function() {
            this.currentTimeout = window.setTimeout(function() {
                loader.$loader
                    .removeClass("loading")
                    .addClass("error");
                this.currentTimeout = window.setTimeout(loader.hide, 3000);
                loader.isLoading = false;
            }, 100);
        },
        hide: function() {
            if (!loader.isLoading) {
                loader.$loader.removeClass("success").removeClass("error");
            }
            this.currentTimeout = null;
        }
    };

    loader.init();

    //form contact en ajax
    $('#contactForm').on('submit', function(e) {
        e.preventDefault(); // J'empêche le comportement par défaut du navigateur, c-à-d de soumettre le formulaire      
    });

    $("#contactForm").on("formvalid.zf.abide", function(ev,frm){postForm(ev,frm);});

    $('#contactFormFooter').on('submit', function(e) {
        e.preventDefault(); // J'empêche le comportement par défaut du navigateur, c-à-d de soumettre le formulaire      
    });

    $("#contactFormFooter").on("formvalid.zf.abide", function(ev,frm) {
        postForm(ev,frm);
    });
});